
document.addEventListener("DOMContentLoaded", function () {
  console.log('Start UnicoPag Snippet')

  const interceptedElements = new WeakSet();
  let observer;

  // Função para substituir o botão de checkout e adicionar o evento de clique
  function interceptCheckoutButton(button) {
      if (!button || interceptedElements.has(button)) return;
      interceptedElements.add(button);

      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          console.log("Redirect unicopag!");

          if (typeof window.unicopag_buy === "function") {
              window.unicopag_buy();
          } else {
              console.error("Função unicopag_buy não encontrada.");
          }
      });
  }

  function interceptCheckoutForm(form) {
      if (!form || interceptedElements.has(form)) return;
      interceptedElements.add(form);

      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);

      newForm.addEventListener("submit", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          console.log("Interceptado: Envio do formulário de checkout bloqueado!");

          if (typeof window.unicopag_buy === "function") {
              window.unicopag_buy();
          } else {
              console.error("Função unicopag_buy não encontrada.");
          }
      });
  }

  function interceptAllCheckoutElements() {
      let checkoutElements = document.querySelectorAll(
          '#checkout,' +
          'a[href="/checkout"], ' +
          'form[action="/cart"] input[type="submit"], ' +
          'form[action="/cart"] button[type="submit"], ' +
          'form[action="/cart"] input[name="checkout"], ' +
          'form[action="/cart"] button[name="checkout"], ' +
          'button[form="cart"],' +
          '.shopify-payment-button__button'
      );

      checkoutElements.forEach(interceptCheckoutButton);

      let checkoutForms = document.querySelectorAll(
          'form[action="/checkout"], form[action="/cart"]'
      );

      checkoutForms.forEach(interceptCheckoutForm);
  }

  function setupObserver() {
      observer = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
              mutation.addedNodes.forEach(node => {
                  if (node.nodeType === 1 && !interceptedElements.has(node)) {
                      // Verificar se o nó adicionado corresponde a um dos elementos de checkout
                      if (node.matches('a[href="/checkout"], form[action="/cart"], .shopify-payment-button__button')) {
                          interceptCheckoutButton(node);
                      } else {
                          // Verificar os elementos dentro do nó adicionado
                          node.querySelectorAll('a[href="/checkout"], form[action="/cart"], .shopify-payment-button__button').forEach(interceptCheckoutButton);
                      }
                  }
              });
          });
      });

      observer.observe(document.body, { childList: true, subtree: true });
  }

  // Função para desconectar o MutationObserver temporariamente
  function stopObserving() {
      if (observer) {
          observer.disconnect();
      }
  }

  // Função para retomar o MutationObserver
  function startObserving() {
    console.log('start')
      if (!observer) {
          setupObserver(); // Inicializa o observer caso ainda não tenha sido configurado
      }
  }

  // Interceptar elementos que já existem na página
  interceptAllCheckoutElements();

  // Iniciar o observer
  startObserving();
});

